(() => {
  const query = window.matchMedia('(max-width: 989px)');
  const drawer = document.querySelector('#shopify-section-header header-drawer');
  if (!drawer) return;
  let serial = 0;
  let frame = 0;
  const managed = new Map();
  const seriesOrders = new Map();
  const collator = new Intl.Collator(document.documentElement.lang || 'en', {
    sensitivity: 'base', numeric: true, ignorePunctuation: true
  });
  const sortSeries = (submenu) => {
    const items = Array.from(submenu.children);
    const original = seriesOrders.get(submenu) || [];
    items.forEach((item) => {
      if (!original.includes(item)) original.push(item);
    });
    seriesOrders.set(submenu, original);
    const title = (item) => (item.querySelector('.mm-title')?.textContent || item.textContent).trim();
    const sorted = [...items].sort((a, b) => collator.compare(title(a), title(b)));
    if (sorted.some((item, index) => item !== items[index])) {
      sorted.forEach((item) => submenu.appendChild(item));
    }
  };
  const setOpen = (item, open) => {
    const entry = managed.get(item);
    if (!entry) return;
    item.dataset.ssMobileOpen = String(open);
    entry.button.setAttribute('aria-expanded', String(open));
    entry.button.textContent = open ? '−' : '+';
    if (open) {
      entry.submenu.querySelectorAll('img[data-src]').forEach((img) => {
        if (!img.getAttribute('src')) {
          img.loading = 'lazy';
          img.src = img.getAttribute('data-src');
        }
      });
    }
  };
  const cleanup = () => {
    managed.forEach((entry, item) => {
      entry.button.remove();
      item.removeAttribute('data-ss-mobile-parent');
      item.removeAttribute('data-ss-mobile-open');
      entry.submenu.removeAttribute('data-ss-mobile-submenu');
      if (entry.generatedId) entry.submenu.removeAttribute('id');
    });
    managed.clear();
    seriesOrders.forEach((items, submenu) => {
      items.forEach((item) => {
        if (item.parentElement === submenu) submenu.appendChild(item);
      });
    });
    seriesOrders.clear();
  };
  const enhance = () => {
    frame = 0;
    if (!query.matches) return;
    drawer.querySelectorAll('.buddha-menu-item').forEach((item) => {
      const anchor = item.querySelector(':scope > a');
      const submenu = item.querySelector(':scope > ul.mm-submenu');
      if (!anchor || !submenu) return;
      const label = anchor.querySelector('.mm-title')?.textContent.trim() || anchor.getAttribute('aria-label') || anchor.textContent.trim();
      if (label.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase() === 'pokemon series') {
        sortSeries(submenu);
      }
      const existing = managed.get(item);
      if (existing && existing.submenu === submenu && existing.button.isConnected) return;
      if (existing) existing.button.remove();
      const button = document.createElement('button');
      const generatedId = !submenu.id;
      if (generatedId) submenu.id = 'ss-mobile-submenu-' + (++serial);
      button.type = 'button';
      button.className = 'ss-mobile-submenu-toggle';
      button.setAttribute('aria-label', label);
      button.setAttribute('aria-controls', submenu.id);
      button.setAttribute('aria-expanded', 'false');
      button.textContent = '+';
      item.dataset.ssMobileParent = '';
      submenu.dataset.ssMobileSubmenu = '';
      managed.set(item, {button, submenu, generatedId});
      anchor.after(button);
      setOpen(item, false);
    });
  };
  drawer.addEventListener('click', (event) => {
    if (!query.matches) return;
    const button = event.target.closest('.ss-mobile-submenu-toggle');
    const anchor = event.target.closest('a');
    let item = button?.parentElement;
    if (!item && anchor?.parentElement.matches('[data-ss-mobile-parent]') &&
        (anchor.getAttribute('data-href') === 'no-link' || anchor.getAttribute('href') === '#')) {
      item = anchor.parentElement;
    }
    if (!item || !managed.has(item)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    setOpen(item, item.dataset.ssMobileOpen !== 'true');
  }, true);
  drawer.addEventListener('keydown', (event) => {
    if (!query.matches) return;
    const item = event.target.closest('[data-ss-mobile-parent]');
    if (!item || !managed.has(item)) return;
    const entry = managed.get(item);
    if (event.key === 'Escape' && item.dataset.ssMobileOpen === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
      setOpen(item, false);
      entry.button.focus();
    } else if (event.key === ' ' && event.target.matches('a[data-href="no-link"]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      setOpen(item, item.dataset.ssMobileOpen !== 'true');
    }
  }, true);
  drawer.querySelector('details').addEventListener('toggle', (event) => {
    if (!event.target.open) managed.forEach((_, item) => setOpen(item, false));
  });
  new MutationObserver(() => {
    if (query.matches && !frame) frame = requestAnimationFrame(enhance);
  }).observe(drawer, {childList: true, subtree: true});
  query.addEventListener('change', () => query.matches ? enhance() : cleanup());
  enhance();
})();
